<form [formGroup]="preShipmentSurvey">
<div class="form-row">
  <div class="form-group col-md-6">
    <label for="pre-move-survey-type">Pre-Move Survey Type:</label>
    <select id="pre-move-survey-type"
            class="w-100"
            formControlName="preMoveSurveyType">
      <option value=""
              selected>None</option>
      <option *ngFor="let type of surveyTypes">{{ type }}</option>
    </select>
  </div>
  <div class="form-group col-md-6">
    <label for="pre-move-survey-req">Pre-Move Survey Required:</label>
    <select id="pre-move-survey-req"
            class="w-100"
            formControlName="preMoveSurveyReqd">
      <option value=""
              selected>None</option>
      <option *ngFor="let type of surveyReqTypes">{{type}}</option>
    </select>
  </div>
</div>
</form>
